/**
 * --------------------------------------------------
 * Marketo 3rd party integration
 * 
 * @module marketo
 * @see module:marketo
 * --------------------------------------------------
 */

import Forms from './forms';

export default {

    selectedClassName: 'selected',
    dirtyClassName: 'isDirty',
    arrayFrom: Function.prototype.call.bind(Array.prototype.slice),
    $formElem: '.rt-js-marketo-form',
    $marketoId: null,
    $marketoUrl: null,
    $marketoFormId: [],

    setup: function () {
        // Initialize Marketo forms
        this.$marketoId = $('meta[name="marketo-id"]').attr('content');
        this.$marketoUrl = "//" + $('meta[name="marketo-url"]').attr('content');

        // Get all form elements
        const $forms = $(this.$formElem);

        // Loop through all the elements
        for (let i = 0; i < $forms.length; i++) {
            const $form = $forms.eq(i);
            const formId = $form.data('formid');
            this.$marketoFormId[i] = formId;

            // Initialize Marketo form if ID is present
            if (formId) {
                this.marketo(formId);
            }
        }
    },


    marketo: function ($id) {
        const _self = this;

        // Validate if MktoForms2 is loaded and $id is defined
        if(window.MktoForms2 && $id){
            // load form
            MktoForms2.loadForm(_self.$marketoUrl, _self.$marketoId, $id, function(form) {

                // Validate if form is not null
                if(form){

                    const $formElem = $('#mktoForm_' + $id);
                    const $formContainer = $('#form_' + $id);
                    const $formComplete = $('#form-completed_' + $id);

                    //Remove loading message, if there is one
                    $formElem.find('.marketo-loading').remove();

                    // Remove default styles
                    _self._destyleMktoForm(form);

                    // Add accesibility features
                    _self._addAccesibilityFeatures(form);

                    // Adding events
                    Forms.find('.input');

                    // Add an onSuccess handler that show the "thank you" div
                    form.onSuccess(function () {
                        $formContainer.addClass('is-hidden');
                        $formComplete.removeClass('is-hidden');

                        // adding button hide/show success message
                        /*$formComplete.fadeIn("slow");
                        $formComplete.removeAttr("style");*/
                        
                        // Scrolling back to top to show the Thank you message in resources pages
                       $('html, body').animate({
                            scrollTop: $formComplete.offset().top - 100
                        }, 500);

                        return false;
                    });
                }
            });
        }
    },

    // Remove default style tags from Marketo form
   _removeFormStyles: function (aForm){
        var styledEls = this.arrayFrom(aForm.querySelectorAll("[style]")).concat(aForm);
        for (var i = 0; i < styledEls.length; i++) {
            styledEls[i].removeAttribute("style");
        }
    },

    // Remove default styles from Marketo form
    _destyleMktoForm: function (form) {

        const _self = this;
        const $form = $(this.$formElem);

        // Validate if form is null
        if (form === null) {
            $form.parent().css('display', 'none');

        } else {
            const formElem = form.getFormElem()[0];
    
            // remove element styles from <form> and children
            _self._removeFormStyles(formElem);
    
            // disable remote stylesheets and local <style>s
            let styleSheets = this.arrayFrom(document.styleSheets);
            for(let i = 0; i < styleSheets.length; i++) {
                if ( [mktoForms2BaseStyle,mktoForms2ThemeStyle].indexOf(styleSheets[i].ownerNode) != -1 || formElem.contains(styleSheets[i].ownerNode) ) {
                    styleSheets[i].disabled = true;
                }
            }
    
            // adding our own class
            $('.mktoFieldWrap').addClass('input');
            $('.mktoFormRow select').parent('.mktoFieldWrap').addClass('isDirty');
            //add class on click
            $('.mktoRadioList input').on('click', function(){
                $(document).ready(function(){
                  $('.mktoFormRow textarea, .mktoFormRow select, .mktoRadioList')
                  .parent('.mktoFieldWrap')
                  .addClass('input isDirty');
                  //run cleaner
                  _self._removeFormStyles(formElem);
                 });
            });
        }
    },

    // Add accesibility features to Marketo forms
    _addAccesibilityFeatures: function (form) {
        const formEl = form.getFormElem()[0];
        const formFields = $(formEl).find('.mktoField');
        const formLabels = $(formEl).find('label[id^="LblmktoCheckbox"]'); // Add only to checkboxes
        const formButtons = $(formEl).find('.mktoButton');

       // Get all the fields, labels, and buttons
        let elements = Array.from(formFields).concat(Array.from(formLabels), Array.from(formButtons));

        // Loop over all the elements and set the attribute
        elements.forEach(function(element) {
            element.setAttribute('tabindex', '0');
        });
    }
};